import $ from 'jquery';

/**
 * The 'amd' property may not be present on the select2 object, this is why we're using optional chaining.
 * For example in our test environment, the amd property is not present. In the browser it is present nevertheless.
 *
 * @param name - the name of the module to load
 * @return - the loaded select module
 */
export const select2Require = (name: string) => $.prototype.select2?.amd.require(name);
